import { PostJson } from "../core/Helper";

export class VersionService {
  /**
   * Get branch using new controller
   * @param {*} data
   * @param {*} user
   * @returns
   */
  static async CurrentVersion(data, user) {
    let result = await PostJson("/api/versions/get-current", {
      data,
      user,
    });

    return result ?? null;
  }

  static async IsCurrentVersion(data) {
    let ver = await this.CurrentVersion();

    if (process.env.REACT_APP_VERSION === ver?.version) {
      //console.log("version matched.");
      return true;
    } else {
      console.log("version missmatch.");
      return false;
    }
  }
}
